module.exports = __webpack_public_path__ + "img/savecsv.5f6b603c.png";